var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "Eye",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","className":"dibsvg-svg dibsvg-eye","viewBox":"0 0 250 250"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <path d="M248.1 131.2c-40.4-53.9-83.3-80.4-127.4-78.8-29 1.1-58.7 14.8-85.9 39.7-15.4 14.1-25.8 27.8-30.2 34l-2.2 1.5.6.9c-.4.6-.7 1-.7 1.1l-1.8 2.9 2.3 2.5C41 178.1 82 199.9 124.7 199.9h2.8c36.7-.8 67.5-17.9 87-32.2 21-15.3 33.2-30.3 33.7-30.9l2.2-2.7-2.3-2.9zm-121 59.7c-40.1.9-78.9-19-115.4-59.2C21 118.5 63.4 63.5 121 61.4c40.3-1.5 79.8 22.9 117.7 72.3-10.2 11.4-53.9 55.9-111.6 57.2z"/>
  <circle cx="124.3" cy="126.5" r="42.5"/>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/eye.svg